export type UidSource = 'local' | 'session' | 'memory';

export interface Identity {
  readonly uid: string;
  readonly us: UidSource; // uid 저장소 출처
  readonly nw: boolean; // 신규 여부
  readonly pv: number; // 누적 방문
  readonly lv: number; // 직전 방문 경과 ms (-1 = 없음)
}

const UID_KEY = 'ajae.uid.v1';
const VISIT_KEY = 'ajae.visit.v1';

function rand(): string {
  try {
    const b = new Uint32Array(2);
    crypto.getRandomValues(b);
    return `${(b[0] as number).toString(36)}${(b[1] as number).toString(36)}`;
  } catch {
    return `x${String(Date.now()).slice(-8)}`;
  }
}

/**
 * uid 폴백 체인 — localStorage → sessionStorage → 메모리.
 * 어느 층에서 왔는지(us)를 남겨야 "사람 수"가 어긋난 표본을 사후에 분리할 수 있다.
 */
export function readIdentity(): Identity {
  let uid = '';
  let us: UidSource = 'memory';
  let nw = false;
  try {
    const hit = localStorage.getItem(UID_KEY);
    if (hit !== null && hit.length > 0) {
      uid = hit;
      us = 'local';
    } else {
      uid = rand();
      localStorage.setItem(UID_KEY, uid);
      us = 'local';
      nw = true;
    }
  } catch {
    try {
      const hit = sessionStorage.getItem(UID_KEY);
      if (hit !== null && hit.length > 0) {
        uid = hit;
        us = 'session';
      } else {
        uid = rand();
        sessionStorage.setItem(UID_KEY, uid);
        us = 'session';
        nw = true;
      }
    } catch {
      uid = rand();
      us = 'memory';
      nw = true;
    }
  }

  let pv = 1;
  let lv = -1;
  try {
    const raw = localStorage.getItem(VISIT_KEY);
    if (raw !== null) {
      const prev = JSON.parse(raw) as { n?: number; t?: number };
      pv = (prev.n ?? 0) + 1;
      lv = prev.t === undefined ? -1 : Date.now() - prev.t;
    }
    localStorage.setItem(VISIT_KEY, JSON.stringify({ n: pv, t: Date.now() }));
  } catch {
    /* 저장 실패는 계측 손실일 뿐 게임 실패가 아니다 */
  }
  return { uid, us, nw, pv, lv };
}
